import styled from 'styled-components';

interface BottomFloationButtonProps {
  handleButtonClick: () => void;
  title: string;
  icon: JSX.Element;
}

export const BottomFloatingButton = ({ handleButtonClick, icon, title }: BottomFloationButtonProps) => {
  return (
    <FloatingButtonWrapper>
      <Button onClick={handleButtonClick}>
        {icon && icon}
        <ButtonText>{title}</ButtonText>
      </Button>
    </FloatingButtonWrapper>
  );
};

const FloatingButtonWrapper = styled.div`
  width: 100%;
  position: absolute;
  top: 0px;
  z-index: 110;
`;

const Button = styled.button`
  height: 52px;

  display: flex;
  align-items: center;

  position: absolute;

  bottom: 16px;
  right: 16px;

  padding: var(--radius-large, 16px);

  gap: 8px;

  border-radius: var(--radius-round, 80px);
  background: var(--Light-Scheme-Color-primary-blue, #196eff);
`;

const ButtonText = styled.span`
  max-width: '150px';

  display: -webkit-box;
  max-height: 42px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  overflow: hidden;
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;

  transition-property: max-width;
  transition-duration: 0.1s;
  transition-timing-function: ease-in-out;
`;
